import { render, staticRenderFns } from "./PageDropdown.vue?vue&type=template&id=24166016&"
import script from "./PageDropdown.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageDropdown.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports